export const COURSE_STATE = {
  locked: "Locked",
  inProcess: "InProcess",
};

export const CourseStatus = {
  LOCK : 0,
  COMPLETED : 1,
  IN_PROGRESS : 2,
}
